import { render, staticRenderFns } from "./YuzUcDavetiyesininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=template&id=1111d046"
import script from "./YuzUcDavetiyesininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./YuzUcDavetiyesininTebligeCikartilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports